import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

export const api = createApi({
  baseQuery,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: 'auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    loginWithAzure: builder.mutation({
      query: (accessToken) => {
        return {
          url: 'auth/loginWithAzure',
          method: 'POST',
          body: { token: accessToken },
        };
      },
    }),
    loginUid: builder.mutation({
      query: (uid) => ({
        url: 'auth/login-uid',
        method: 'POST',
        body: { uid },
      }),
    }),
    protected: builder.mutation({
      query: () => 'auth/protected',
    }),
    forgotPassword: builder.mutation({
      query: (credentials) => ({
        url: 'auth/forgot-password',
        method: 'POST',
        body: credentials,
      }),
    }),
    resetPassword: builder.mutation({
      query: (body) => ({
        url: 'auth/reset-password',
        method: 'POST',
        body,
      }),
    }),
    logout: builder.query({
      query: () => 'auth/logout',
    }),
  }),
});

export const {
  useLoginMutation,
  useLoginWithAzureMutation,
  useLoginUidMutation,
  useProtectedMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useLazyLogoutQuery,
} = api;
